module.exports = __webpack_public_path__ + "img/funds-box-line.cbf8f5ec.svg";